module.exports = __webpack_public_path__ + "static/media/gmail-subject-correct.71ef6344.png";